import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ColorInfo } from '@ddv/charts';
import { SlicerValueColorConfig } from '@ddv/models';
import { IconComponent } from '@hs/ui-core-presentation';

import { MultiColorPickerComponent } from '../multi-color-picker/multi-color-picker.component';

@Component({
    selector: 'ddv-line-chart-color',
    templateUrl: './line-chart-color.component.html',
    styleUrls: ['./line-chart-color.component.scss'],
    imports: [CommonModule, FormsModule, IconComponent, MultiColorPickerComponent],
})
export class LineChartColorComponent {
    @Input() colorConfigList: SlicerValueColorConfig[] = [];
    @Input() colorValues: ColorInfo[] = [];
    @Input() dropdownClass: string | undefined;
    @Input() isReadOnly = false;

    @Output() colorSelected = new EventEmitter<{ color: string, el: HTMLElement, index: number }>();

    protected addLineChartCustomAttributeValue(index: number): void {
        if (this.colorConfigList[index].attributeValue) {
            const { lineChartCustomConfig, ...rest } = this.colorConfigList[index];
            this.colorConfigList[index] = rest;
        }
    }

    protected onColorSelected(selected: { color: string, el: HTMLElement }, index: number): void {
        this.colorSelected.emit({ ...selected, index });
    }

    protected addAdditionalLineChartColor(): void {
        this.colorConfigList.push({
            attributeValue: '',
            attributeColorName: '',
            lineChartCustomConfig: true,
        });
    }
}
